import React from 'react'
import './index.css';
import { ReactComponent as SpinnerSvg } from '../../media/loading.svg'
import errorImg from '../../media/attention.svg'

const Spinner = () => <SpinnerSvg class='loading'/>

const LoadingScreen = ({ text, textColor, logoSrc, isLoading}) => (
    <>
        <div className='logo'>
            <img src={logoSrc} alt=""/>
        </div>
        <div className='downside'>
            {
                isLoading
                    ?
                    <Spinner/>
                    :
                    <img src={errorImg} alt='errorImg'/>
            }
            <h1 style={{ color: textColor }}>{text}</h1>
        </div>
    </>
)

export default LoadingScreen